export const MODULE_INSPECTIONS = "module:inspections"
export const INSPECTIONS_CREATE = "inspections:create"
export const MODULE_MERCHANDISING = "module:merchandising"
export const MERCHANDISING_REVIEWED_ITEMS = "merchandising:reviewed-items"
export const MODULE_INVENTORY = "module:inventory"
export const MODULE_REPORTS = "module:reports"
export const ADMIN_REPORTS_SALES = "admin:reports:sales"
export const ADMIN_REPORTS_SAVED = "admin:reports:saved"
export const SELECT_THEME = "theme:select"
export const FLOORFOUND_ADMIN = "floorfound:admin"

const permissions = {
  inspector: {
    static: [
      MODULE_INSPECTIONS
    ]
  },
  merchandiser: {
    static: [
      MODULE_MERCHANDISING
    ]
  },
  consigner: {
    static: [
      MODULE_INVENTORY
    ]
  },
  'floorfound-admin': {
    static: [
      MODULE_INSPECTIONS,
      INSPECTIONS_CREATE,
      MODULE_MERCHANDISING,
      MERCHANDISING_REVIEWED_ITEMS,
      MODULE_REPORTS,
      ADMIN_REPORTS_SALES,
      ADMIN_REPORTS_SAVED,
      FLOORFOUND_ADMIN,
      SELECT_THEME
    ]
    // dynamic: {
    //   "posts:edit": ({userId, postOwnerId}) => {
    //     if (!userId || !postOwnerId) return false;
    //     return userId === postOwnerId;
    //   }
    // }
  }
};

export const defaultRoutes = {
  inspector: "/app/inspection-list",
  merchandiser: "/app/merchandising-list",
  consigner: "/app/inventory-current",
  'floorfound-admin': "/app/inspection-list",
}

export const defaultMobileRoutes  = {
  inspector: "/app/scan",
  merchandiser: "/app/scan",
  consigner: "/app/scan",
  'floorfound-admin': "/app/scan",
}

export default permissions;